import { usePersonStore } from '~/stores/person';

// Shared open-state for FeatureLockedModal: mode is derived from whether the selected/loaded
// person (impersonation-aware) already holds a license (upgrade-required) or none (no-license).
// The feature gates that open this modal are themselves keyed off personStore.person, so the
// CTA must act on that person's license — not the authenticated buyer's.
export const useFeatureLockedModal = () => {
    const personStore = usePersonStore();

    const featureModalOpen = ref(false);
    const featureModalMode = computed<'no-license' | 'upgrade-required'>(() =>
        personStore.person?.license?.id ? 'upgrade-required' : 'no-license',
    );

    function openFeatureModal() {
        featureModalOpen.value = true;
    }

    return { featureModalOpen, featureModalMode, openFeatureModal };
};
